let currentDevice = '';
import {ebus} from '../vendor/ebus';

export function updateDeviceClass() {
  let newDevice = '';
  let deviceClass = '';
  if (window.matchMedia('(max-width: 960px)').matches) {
    newDevice = 'xs';
  } else {
    newDevice = 'md';
  }
  deviceClass = '' + newDevice;

  let bodyEl = document.getElementsByTagName('BODY')[0];

  let vdevice = 'vdevice-not-xs';
  bodyEl.classList.remove('vdevice-xs', 'vdevice-not-xs');
  if (window.matchMedia('(max-width: 599px)').matches) {
    vdevice = 'vdevice-xs';
    deviceClass = 'xxs';
  }
  bodyEl.classList.add(vdevice);

  if (window.matchMedia('(min-height: 1200px)').matches) {
    bodyEl.classList.add('highScreen');
  } else {
    bodyEl.classList.remove('highScreen');
  }

  ebus.$emit('setDeviceClass', deviceClass);

  if (currentDevice !== newDevice) {
    currentDevice = newDevice;
    console.log('break to: ' + currentDevice);
    bodyEl.classList.remove('device-xs', 'device-md');
    bodyEl.classList.add('device-' + newDevice);
    ebus.$emit('deviceClassesUpdated');
  }
}

export function updateKioskStyle() {
  let bodyEl = document.getElementsByTagName('BODY')[0];
  bodyEl.classList.add('isKiosk');

  const style = document.createElement("style");
  style.textContent = `
      body::-webkit-scrollbar {
        width: 0px;
        background: transparent;
      }
    `;
  document.head.appendChild(style);
}

export function getCurrentDevice() {
  return currentDevice;
}

window.addEventListener('resize', () => {
  updateDeviceClass();
});
